<template>
    <v-navigation-drawer
        app
        class="sidebar"
        clipped
        floating
        :mini-variant.sync="mini"
        mini-variant-width="72"
        permanent>
        <sidebar-geography></sidebar-geography>
        <v-list>
            <v-list-item
                exact
                :key="narrativeStats[narrative].name"
                :title="narrativeStats[narrative].display"
                v-for="narrative in narratives">
                <v-chip
                    :class="`sidebar__chip sidebar__chip--${narrativeStats[narrative].name}`"
                    :to="{ name: narrativeStats[narrative].to }">
                    {{narrativeStats[narrative].display}}
                </v-chip>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import {narrativeStats} from "../../constants/narrativeStats";
import stateStats from "../../constants/stateStats.json";
import SidebarGeography from './SidebarGeography.vue';

export default {
    name: "sidebar",
    components: { SidebarGeography },
    data() {
        return {
            mini: false,
            narrativeStats: narrativeStats,
            stateStats: stateStats,
        }
    },
    computed: {
        narrative(){
            if(this.$route.name != 'state'){
                return this.narrativeStats[this.$route.name];
            } else {
                return this.narrativeStats['all'];
            }
        },
        narratives() {
           return ['all', 'technology', 'gotv', 'poc', 'aapi', 'black', 'latino', 'native_american', 'lgbtq', 'women', 'flipped', 'new'];
        },
        technology(){
            return {
                name: 'technology',
                display: 'Technology',
                mobileDisplay: 'Technology',
                description: 'The tools and technology that powered campaigns up and down the ballot. DSPolitical is proud to have served digital ads in all 50 states at a greater scale than ever before!',
                stats: [
                    {
                        description: "Total Impressions Served in the 2022 Presidential elections",
                        value: '3.3B'
                    },
                    {
                        description: "Impressions per second from October 20th to Election Day",
                        value: '1,023' 
                    },
                    {
                        description: "Total Number of Candidates and Causes served",
                        value: '1,472' 
                    },
                    {
                        description: "Number of GOTV campaigns ran",
                        value: '279' 
                    },
                    {
                        description: "Number of Campaigns on self-serve platforms",
                        value: '795' 
                    },
                ],
                to: 'technology'
            };
        }
    }
}
</script>

<style lang="scss">
    @import "../../styles/_variables.scss";
    @import "../../styles/_mixins.scss";

    .sidebar{
        background: transparent!important;
        //@media screen and (min-width: $lg) {
        //    width: 300px !important;
        //}
        &__chip{
            border: 1px solid;
            border-radius: 20px!important;
            height: 40px!important;
            padding: 0 16px;

            .v-chip__content{
                font-family: 'Libre Franklin', 'Roboto', sans-serif;
                font-size: 16px;
                font-weight: bold;
            }
            

            @media screen and (min-width: $lg) {
                font-size: 16px !important;
            }

            @media screen and (min-width: $xl) {
                font-size: 18px !important;
            }

            &--all{
                @include sideBarNarrativeChip($all, $allLighten2)
            }
            &--aapi{
                @include sideBarNarrativeChip($aapi, $aapiLighten2)
            }
            &--black{
                @include sideBarNarrativeChip($black, $blackLighten2)
            }
            &--flipped{
                @include sideBarNarrativeChip($flipped, $flippedLighten2)
            }
            &--gotv{
                @include sideBarNarrativeChip($gotv, $gotvLighten2)
            }
            &--latino{
                @include sideBarNarrativeChip($latino, $latinoLighten2)
            }
            &--lgbtq{
                @include sideBarNarrativeChip($lgbtq, $lgbtqLighten2)
            }
            &--native_american{
                @include sideBarNarrativeChip($nativeAmerican, $nativeAmericanLighten2)
            }
            &--new{
                @include sideBarNarrativeChip($new, $newLighten2)
            }
            &--poc{
                @include sideBarNarrativeChip($poc, $pocLighten2)
            }
            &--technology{
                @include sideBarNarrativeChip($technology, $technologyLighten2)
            }
            &--women{
                @include sideBarNarrativeChip($women, $womenLighten2)
            }
        }
    }
</style>